@import '../../themes/capsule.globals';

:host {
  --button-size: 32px;

  display: flex;
}

:host {
  ::slotted(cpsl-button:first-child) {
    --button-border-radius-top-end: 0px;
    --button-border-radius-bottom-end: 0px;
  }
  ::slotted(cpsl-button:last-child) {
    --button-border-width-start: 0px;
    --button-border-radius-top-start: 0px;
    --button-border-radius-bottom-start: 0px;
  }
  ::slotted(cpsl-button:not(:first-child):not(:last-child)) {
    --button-border-width-start: 0px;
    --button-border-radius-top-start: 0px;
    --button-border-radius-bottom-start: 0px;
    --button-border-radius-top-end: 0px;
    --button-border-radius-bottom-end: 0px;
  }
  ::slotted(cpsl-button) {
    --button-color: var(--cpsl-color-text-tertiary);
    --button-padding-start: 0px;
    --button-padding-end: 0px;
    --button-padding-top: 0px;
    --button-padding-bottom: 0px;
    --button-border-radius: var(--cpsl-border-radius-button-group);
    height: var(--button-size);
    width: var(--button-size);
  }
  ::slotted(cpsl-button.selected) {
    --button-color: var(--cpsl-color-text-primary);
  }
}
